import React, { FC, SVGProps } from 'react';

export const Trusted: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="80" height="80" rx="40" fill="#B1CB8F" />
    <path
      d="M22.0611 30.6424C21.9861 29.0663 22.9276 27.6279 24.3683 26.9843L38.3683 20.7291C39.4066 20.2651 40.5934 20.2651 41.6317 20.7291L55.6317 26.9843C57.0724 27.6279 58.0139 29.0663 57.9389 30.6424C56.9417 51.6075 44.0106 60 40 60C35.9894 60 23.0583 51.6075 22.0611 30.6424Z"
      stroke="#26313B"
      strokeWidth="2"
    />
    <circle
      cx="40"
      cy="38"
      r="7"
      fill="#FFCFAD"
      stroke="#26313B"
      strokeWidth="2"
    />
  </svg>
);
